/* eslint-disable */ import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain';
export const createPresets = createPresetsFactory();
export const generatedPresets = createPresets([
    {
        name: 'Basic Volleyball Shorts',
        description: 'Simple starting configuration',
        rootEntityType: 'VolleyballShorts',
        tags: [
            'empty-volleyball-shorts'
        ],
        initialDomainEntities: [
            {
                id: 'VolleyballShorts-1',
                type: 'VolleyballShorts',
                collection: 'solid',
                design: 'white',
                liner: 'none',
                fabric: '90/10 stretch',
                size: 'l',
                inseam: 0
            },
            {
                id: 'LeftLeg-1',
                type: 'LeftLeg',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'RightLeg-1',
                type: 'RightLeg',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'Waistband-1',
                type: 'Waistband',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'Drawstring-1',
                type: 'Drawstring',
                color: 'white'
            }
        ]
    }
]);

//# sourceMappingURL=presets.js.map